export interface ArticleData {
  id: number;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  categorySlug: string;
  coverImage: string;
  author: string;
  publishDate: string;
  readTime: string;
  views: number;
  tags: string[];
  featured: boolean;
}

export const articles: ArticleData[] = [
  {
    id: 1,
    title: '2026年最值得期待的十部国产剧，每一部都是良心之作',
    excerpt: '从古装大剧到现代都市，从悬疑推理到温情治愈，这十部即将上线的国产剧绝对不容错过。制作精良、演员阵容强大，你准备好了吗？',
    content: `<p>2026年的国产电视剧市场可谓百花齐放，各大平台纷纷推出了精心打造的原创剧集。我们为大家精选了十部最值得期待的国产剧，每一部都堪称良心之作。</p>
<h2>一、《长安十二时辰》续集</h2>
<p>作为现象级古装剧的续作，《长安十二时辰》第二季延续了第一季的高水准制作。原班人马回归，故事将聚焦于新的时间线和更加复杂的权谋斗争。制作团队在服化道方面投入了更大成本，力求还原大唐盛世的恢弘气势。</p>
<h2>二、《深海迷踪》</h2>
<p>这是一部融合了科幻与悬疑元素的创新型剧集。故事讲述了一支海洋科考队在深海发现神秘遗迹后引发的一系列离奇事件。该剧采用了最先进的水下拍摄技术，视觉效果堪比好莱坞大片。</p>
<h2>三、《人间烟火色》</h2>
<p>以90年代小城为背景的温情年代剧，讲述了几代人在时代变迁中的生活故事。细腻的情感刻画和真实的时代还原是该剧最大的看点。演员全员演技在线，每一个角色都立体饱满。</p>
<h2>四、《暗夜追踪者》</h2>
<p>悬疑犯罪题材的又一力作，以一名女刑警的视角展开。剧情节奏紧凑，案件设计巧妙，每一集都有让人意想不到的反转。该剧在剧本创作阶段就邀请了真实刑侦专家参与指导。</p>
<h2>五、《山河万里》</h2>
<p>史诗级古装战争剧，以真实历史事件为背景。剧组辗转多地实景拍摄，战争场面宏大震撼。除了视觉上的冲击，剧中关于家国情怀的探讨也发人深省。</p>
<p>以上只是2026年精彩剧集的冰山一角。随着国产剧制作水平的不断提升，我们有理由相信，未来会有更多优质作品与观众见面。你最期待哪一部呢？</p>`,
    category: '电视剧',
    categorySlug: 'dianshi',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20film%20set%20with%20elaborate%20costumes%20and%20traditional%20architecture%2C%20cinematic%20lighting%2C%20warm%20golden%20tones%2C%20professional%20production%20design%2C%20elegant%20composition%2C%20soft%20atmospheric%20light&width=800&height=450&seq=article-cover-01&orientation=landscape',
    author: '影评人小王',
    publishDate: '2026-08-01',
    readTime: '8分钟',
    views: 15820,
    tags: ['国产剧', '2026新剧', '电视剧推荐', '影视前瞻'],
    featured: true,
  },
  {
    id: 2,
    title: '暑期档电影票房大战：谁将问鼎今年暑期档冠军？',
    excerpt: '暑期档历来是电影市场的必争之地。今年的暑期档竞争格外激烈，多部大制作影片扎堆上映，票房大战一触即发。我们来看看都有哪些种子选手。',
    content: `<p>每年暑期档都是中国电影市场最热闹的时期，今年的竞争激烈程度更胜往年。让我们一起来看看都有哪些热门影片值得关注。</p>
<h2>动作大片阵营</h2>
<p>今年暑期档的动作片阵容堪称豪华。《铁血战士：重生》作为经典IP的重启之作，由好莱坞顶级特效团队打造，预告片中的动作场面就已经让影迷热血沸腾。国产动作片《狂风行动》也不甘示弱，香港金牌动作指导亲自操刀，拳拳到肉的打斗场面令人期待。</p>
<h2>喜剧片对决</h2>
<p>暑期档怎么能少了喜剧片？《欢乐家族3》作为系列第三部，沈腾、马丽再度联手，预告片笑点密集。另一边，《乌龙特工队》由新锐导演执导，以年轻化视角讲述特工故事，有望成为黑马。</p>
<h2>动画电影崛起</h2>
<p>近年来国产动画电影发展迅猛。今年暑期档有《大闹天宫之风云再起》和《深海传说》两部重量级动画上映。前者由中国顶尖动画工作室耗时五年打造，画风精美；后者则以独特的东方美学风格吸引了大量关注。</p>
<h2>文艺片黑马</h2>
<p>除了商业大片，今年暑期档还有几部口碑极佳的文艺片上映。《夏日终曲》在多个国际电影节获得提名，以细腻的情感表达打动了评委和观众。</p>
<p>综合来看，今年暑期档影片类型丰富、质量上乘，无论你喜欢什么类型的电影，都能在影院找到心仪的选择。这个夏天，电影院见！</p>`,
    category: '电影',
    categorySlug: 'dianying',
    coverImage: 'https://readdy.ai/api/search-image?query=modern%20cinema%20lobby%20with%20movie%20posters%20and%20warm%20theater%20lighting%2C%20elegant%20interior%20design%2C%20people%20enjoying%20movies%2C%20cinematic%20atmosphere%2C%20rich%20warm%20colors&width=800&height=450&seq=article-cover-02&orientation=landscape',
    author: '票房观察员',
    publishDate: '2026-07-28',
    readTime: '6分钟',
    views: 23450,
    tags: ['暑期档', '电影票房', '院线电影', '新片推荐'],
    featured: true,
  },
  {
    id: 3,
    title: '《星光大道2026》重磅回归，全新赛制引发热议',
    excerpt: '国内最长寿的音乐选秀节目《星光大道》2026年以全新面貌回归。节目组公布了颠覆性的新赛制，导师阵容也进行了大换血，引发网友热议。',
    content: `<p>作为国内最长寿的音乐选秀节目之一，《星光大道》在2026年迎来了重大改版。全新的赛制、全新的导师阵容，让这档老牌节目焕发出新的活力。</p>
<h2>导师阵容大换血</h2>
<p>本季导师阵容堪称豪华：华语乐坛天后张靓颖、摇滚巨星汪峰、新生代音乐人毛不易、以及韩国著名制作人朴振英组成全新导师团。四位导师风格迥异，各有所长，他们之间的互动也成为节目的一大看点。</p>
<h2>颠覆性赛制</h2>
<p>新赛制最大的变化是引入了"盲选+公开选"双阶段模式。在盲选阶段，导师背对舞台，仅凭声音判断选手实力；进入公开选阶段后，导师可以看到选手的全方位表现。此外，节目还新增了"踢馆赛"和"复活赛"环节，大大增加了节目的悬念和观赏性。</p>
<h2>选手质量创新高</h2>
<p>据节目组透露，今年的报名人数创下了历史新高，选手整体质量也远超往届。不仅有来自各大音乐院校的专业选手，还有大量藏于民间的音乐高手。多元化的选手来源让节目的音乐风格更加丰富多样。</p>
<p>《星光大道2026》的播出无疑将为综艺市场注入一剂强心针，让我们拭目以待！</p>`,
    category: '综艺',
    categorySlug: 'zongyi',
    coverImage: 'https://readdy.ai/api/search-image?query=music%20talent%20show%20stage%20with%20colorful%20spotlights%20and%20dramatic%20lighting%2C%20professional%20TV%20production%20set%2C%20concert%20atmosphere%2C%20warm%20and%20vibrant%20colors&width=800&height=450&seq=article-cover-03&orientation=landscape',
    author: '综艺达人',
    publishDate: '2026-07-25',
    readTime: '5分钟',
    views: 18920,
    tags: ['星光大道', '音乐选秀', '综艺节目', '娱乐资讯'],
    featured: false,
  },
  {
    id: 4,
    title: '国漫崛起！《大圣归来2》制作进度曝光，画面质感超乎想象',
    excerpt: '备受期待的《大圣归来》续集终于有了最新进展。导演透露目前已完成70%的制作，并展示了部分概念图和片段，画面精美程度令人惊叹。',
    content: `<p>距离《大圣归来》第一部上映已经过去了十年，这部被誉为国漫里程碑的作品终于迎来了续集的消息。导演田晓鹏在最近的媒体见面会上透露了《大圣归来2》的最新制作进度。</p>
<h2>制作进度：已完成70%</h2>
<p>田晓鹏表示，续集的制作已经进入最后冲刺阶段。与第一部相比，续集在技术层面有了质的飞跃。团队采用了全新的渲染引擎，角色表情和动作更加细腻流畅。特效场面更是投入了巨大心血，每一个镜头都经过反复打磨。</p>
<h2>画面质感：东方美学的极致呈现</h2>
<p>从现场展示的概念图来看，《大圣归来2》的画面风格延续了第一部的东方美学基调，但在细节和质感上做了大幅提升。云雾缭绕的仙山、气势磅礴的天宫、充满神秘感的妖怪洞府——每一帧都堪称壁纸级别的精美画面。</p>
<h2>故事走向：更加宏大的世界观</h2>
<p>关于剧情，田晓鹏卖了个关子，只透露续集将展现一个更加宏大的神话世界观，大圣将面临前所未有的挑战。新的角色和新的冒险，都将给观众带来全新的体验。</p>
<p>《大圣归来2》预计将于2027年春节档上映。对于国漫爱好者来说，这无疑是最值得期待的消息。</p>`,
    category: '动漫',
    categorySlug: 'dongman',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20animation%20style%20mythological%20monkey%20king%20character%20in%20epic%20landscape%2C%20traditional%20Chinese%20art%20style%2C%20dramatic%20clouds%20and%20mountains%2C%20cinematic%20composition&width=800&height=450&seq=article-cover-04&orientation=landscape',
    author: '二次元观察员',
    publishDate: '2026-07-20',
    readTime: '6分钟',
    views: 32100,
    tags: ['国漫', '大圣归来', '动画电影', '二次元'],
    featured: true,
  },
  {
    id: 5,
    title: '地球脉动第三季：4K镜头下的自然奇迹，每一帧都是壁纸',
    excerpt: 'BBC经典纪录片系列《地球脉动》第三季正式上线。采用8K拍摄、4K输出的制作标准，将地球上的自然奇观以前所未有的清晰度呈现在观众面前。',
    content: `<p>时隔七年，BBC的王牌纪录片系列《地球脉动》终于迎来了第三季。这一次，制作团队带来了更加震撼的视觉盛宴。</p>
<h2>技术升级：8K拍摄，4K输出</h2>
<p>第三季采用了目前最先进的拍摄设备，实现了8K分辨率拍摄和4K分辨率输出的制作标准。这意味着观众可以看到更加细腻、更加真实的画面细节。从显微镜下的昆虫复眼到太空视角的地球全景，每一帧画面都令人叹为观止。</p>
<h2>内容亮点：从未公开的自然奇观</h2>
<p>本季纪录片历时四年拍摄，足迹遍布40多个国家和地区。制作团队深入了许多此前从未被镜头记录过的区域，捕捉到了大量珍贵的自然画面。其中包括深海热泉生态系统的首次高清记录、极地冰川崩塌的震撼瞬间，以及热带雨林树冠层的隐秘世界。</p>
<h2>环保主题：唤起对自然的敬畏</h2>
<p>除了展示自然的壮美，《地球脉动》第三季也更加关注环境问题。纪录片以克制的镜头语言展现了气候变化对地球生态系统的影响，呼吁人们关注环境保护。正如旁白所说："我们只有一个地球，保护她就是保护我们自己。"</p>
<p>这部纪录片不仅是视觉上的享受，更是一次心灵的洗礼。强烈推荐给每一位热爱自然的观众。</p>`,
    category: '纪录片',
    categorySlug: 'jilu',
    coverImage: 'https://readdy.ai/api/search-image?query=stunning%20nature%20documentary%20scene%20with%20wildlife%20in%20savanna%20during%20golden%20hour%2C%20cinematic%20aerial%20photography%2C%20warm%20sunset%20light%2C%20dramatic%20landscape&width=800&height=450&seq=article-cover-05&orientation=landscape',
    author: '自然探索者',
    publishDate: '2026-07-15',
    readTime: '7分钟',
    views: 8900,
    tags: ['纪录片', '地球脉动', 'BBC', '自然'],
    featured: false,
  },
  {
    id: 6,
    title: '娱乐圈上半年大盘点：这些大事你都知道吗？',
    excerpt: '2026年上半年娱乐圈发生了不少大事。从明星婚礼到新剧爆款，从综艺革新到音乐突破，我们一起回顾这半年来娱乐圈的高光时刻。',
    content: `<p>2026年已经过半，娱乐圈在这半年里可谓是精彩纷呈。让我们一起回顾那些让人印象深刻的大事件。</p>
<h2>明星婚礼扎堆</h2>
<p>今年上半年可以说是娱乐圈的"结婚季"。多位一线明星先后举办婚礼，其中最受关注的是顶流小生李承宇与演员赵思雨的世纪婚礼，婚礼现场星光熠熠，半个娱乐圈的明星都到场祝贺。此外，实力派演员周迅与音乐人张亚东的低调婚礼也获得了大量祝福。</p>
<h2>新剧爆款频出</h2>
<p>上半年电视剧市场表现亮眼。《长安十二时辰》续集成为现象级爆款，豆瓣评分高达8.9分，全网播放量突破50亿。都市情感剧《人间烟火色》也凭借细腻的情感刻画收获了大量好评，成为上半年口碑最好的剧集之一。</p>
<h2>综艺节目创新不断</h2>
<p>综艺方面，《星光大道2026》的全新改版引发热议，收视率屡创新高。旅行类综艺《一路向北》以独特的视角和真实的情感打动了观众，成为上半年综艺市场的一匹黑马。</p>
<h2>音乐市场百花齐放</h2>
<p>华语乐坛上半年同样精彩。周杰伦时隔三年发布的新专辑《时光机》上线当天就打破了多项销售纪录。新生代歌手也在不断突破，独立音乐人的作品开始获得更多关注。</p>
<p>下半年的娱乐圈又将带来哪些惊喜？让我们拭目以待。</p>`,
    category: '娱乐资讯',
    categorySlug: 'yule',
    coverImage: 'https://readdy.ai/api/search-image?query=entertainment%20news%20studio%20with%20trending%20topics%20displayed%20on%20large%20screens%2C%20modern%20media%20room%2C%20warm%20ambient%20lighting%2C%20professional%20broadcast%20setting&width=800&height=450&seq=article-cover-06&orientation=landscape',
    author: '娱乐记者小陈',
    publishDate: '2026-07-10',
    readTime: '8分钟',
    views: 45200,
    tags: ['娱乐资讯', '明星', '影视', '盘点'],
    featured: false,
  },
  {
    id: 7,
    title: '武侠剧的复兴：《剑雨江湖》重新定义国产武侠新高度',
    excerpt: '武侠题材在沉寂多年后终于迎来了复兴。《剑雨江湖》以其精良的制作和扎实的剧本，成功唤起了观众对武侠剧的热情。',
    content: `<p>曾经辉煌一时的武侠剧在近年来的电视剧市场中逐渐边缘化。然而，《剑雨江湖》的出现打破了这一局面，为武侠剧的复兴注入了强劲动力。</p>
<h2>精良制作：每一帧都是中国画</h2>
<p>《剑雨江湖》在制作上可谓精益求精。剧组邀请了国内顶尖的武术指导团队，每一个动作场面都经过精心设计，既有传统武侠的韵味，又融入了现代审美。场景美术方面，从烟雨蒙蒙的江南水乡到气势磅礴的西域大漠，美轮美奂的画面让人仿佛置身于一幅幅中国画之中。</p>
<h2>扎实剧本：不只是打打杀杀</h2>
<p>与过去许多只注重视觉效果的武侠剧不同，《剑雨江湖》在剧本上下了真功夫。故事围绕一把传说中的神剑展开，牵扯出江湖各派的恩怨情仇。剧中不仅有精彩的武打场面，更有对人性、道义的深刻探讨。每个角色都有完整的成长弧线，情感线也处理得恰到好处。</p>
<h2>演员表现：全员演技在线</h2>
<p>男主角由当红小生王一博饰演，他将少年剑客的意气风发与内心挣扎演绎得淋漓尽致。女主角由实力派演员刘亦菲出演，她饰演的神秘女侠形象既有英气又不失柔情。配角阵容同样强大，老戏骨与新生代演员的精彩对手戏让整部剧的质感提升了一个档次。</p>
<p>《剑雨江湖》的成功证明，只要用心做内容，武侠剧依然有着广阔的市场空间。</p>`,
    category: '电视剧',
    categorySlug: 'dianshi',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20martial%20arts%20drama%20scene%20with%20warriors%20in%20traditional%20costume%20fighting%20in%20bamboo%20forest%2C%20misty%20atmosphere%2C%20cinematic%20lighting%2C%20epic%20composition&width=800&height=450&seq=article-cover-07&orientation=landscape',
    author: '影评人小王',
    publishDate: '2026-07-05',
    readTime: '7分钟',
    views: 27800,
    tags: ['武侠剧', '国产剧', '剑雨江湖', '影视推荐'],
    featured: false,
  },
  {
    id: 8,
    title: '韩国电影《寄生虫》导演奉俊昊新作即将开机，全球影迷翘首以盼',
    excerpt: '凭借《寄生虫》获得奥斯卡最佳影片的韩国导演奉俊昊，宣布其新作将于今年9月正式开机。影片将延续其独特的社会批判视角。',
    content: `<p>韩国著名导演奉俊昊在《寄生虫》横扫奥斯卡之后，其新作一直备受全球影迷关注。经过长时间的筹备，这部新作终于确定了开机日期。</p>
<h2>新作片名与题材</h2>
<p>据悉，奉俊昊的新片暂定名为《深水之下》。影片将延续导演一贯的社会批判风格，以科幻题材为载体，探讨科技发展对人类社会的影响。故事设定在近未来的首尔，讲述了一个关于人工智能与人性的深刻故事。</p>
<h2>演员阵容</h2>
<p>新片的演员阵容同样令人期待。韩国影帝宋康昊确认回归，这将是两人继《杀人回忆》、《汉江怪物》、《雪国列车》和《寄生虫》之后的第五次合作。此外，好莱坞演员罗伯特·帕丁森也将加盟，为影片增添了国际化元素。</p>
<h2>制作规模</h2>
<p>《深水之下》的制作预算据传高达1.5亿美元，是奉俊昊执导生涯中投资最大的一部作品。影片将采用最先进的视觉特效技术，同时保持导演一贯的写实主义美学风格。</p>
<p>全球影迷都在期待，这位韩国电影大师能否再创辉煌。影片预计2027年底上映。</p>`,
    category: '电影',
    categorySlug: 'dianying',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20film%20director%20on%20movie%20set%20with%20professional%20camera%20equipment%2C%20cinematic%20lighting%2C%20dark%20and%20moody%20atmosphere%2C%20film%20production%20scene&width=800&height=450&seq=article-cover-08&orientation=landscape',
    author: '票房观察员',
    publishDate: '2026-06-30',
    readTime: '5分钟',
    views: 15600,
    tags: ['韩国电影', '奉俊昊', '寄生虫', '新片资讯'],
    featured: false,
  },
  {
    id: 9,
    title: '《海贼王》最终章动画制作决定！25年青春即将画上句号',
    excerpt: '日本集英社正式宣布，《海贼王》动画最终章制作已提上日程。这部陪伴了无数人成长的经典动漫，终于要迎来它的完结篇。',
    content: `<p>对于全球数以亿计的动漫迷来说，这无疑是一个激动人心又略带感伤的消息——连载了25年的《海贼王》，其动画版终于要迎来最终章了。</p>
<h2>官方正式宣布</h2>
<p>日本集英社在最新一期的《周刊少年Jump》上正式宣布，《海贼王》动画最终章的制作已经启动。漫画原作者尾田荣一郎也表示，将亲自参与动画最终章的制作，确保动画的结局能够忠实呈现他心目中的故事终章。</p>
<h2>制作团队：全力以赴</h2>
<p>为了给这部传奇作品一个完美的动画结局，东映动画组建了史上最强的制作团队。据悉，最终章将采用全新的制作标准，画面质量将达到剧场版级别。音乐方面，将继续由田中公平操刀，为这个史诗般的结局谱写动人的乐章。</p>
<h2>粉丝反应：百感交集</h2>
<p>消息一出，全球粉丝的反应可谓百感交集。有人表示"终于等到这一天"，也有人感叹"青春要结束了"。社交媒体上，#海贼王最终章#的话题迅速登上热搜，无数粉丝分享了自己与这部作品的故事。</p>
<p>25年的航海即将到达终点。感谢尾田荣一郎，感谢路飞和他的伙伴们，陪伴我们度过了最美好的青春时光。</p>`,
    category: '动漫',
    categorySlug: 'dongman',
    coverImage: 'https://readdy.ai/api/search-image?query=One%20Piece%20anime%20style%20pirate%20ship%20sailing%20on%20vast%20ocean%20during%20sunset%2C%20golden%20sky%2C%20adventure%20atmosphere%2C%20warm%20colors%2C%20epic%20composition&width=800&height=450&seq=article-cover-09&orientation=landscape',
    author: '二次元观察员',
    publishDate: '2026-06-25',
    readTime: '5分钟',
    views: 56700,
    tags: ['海贼王', '日本动漫', '最终章', '二次元'],
    featured: true,
  },
  {
    id: 10,
    title: '最新韩综《Running Man 2026》全新阵容曝光，收视率能否再创新高？',
    excerpt: '韩国长寿综艺《Running Man》2026年迎来了成员大换血。新加入的三位成员各具特色，能否为这档经典节目注入新的活力？',
    content: `<p>作为韩国最长寿的户外综艺节目之一，《Running Man》在2026年做出了重大调整。随着两位老成员的退出，节目组引入了三位新成员，引发了粉丝的广泛讨论。</p>
<h2>新成员介绍</h2>
<p>新加入的三位成员分别是：演员金秀贤、偶像组合成员车银优，以及搞笑艺人李秀根。金秀贤以其出色的运动能力和机智的反应见长；车银优则带来了年轻粉丝群体的关注；而李秀根的搞笑功力将为节目增添更多笑点。</p>
<h2>新旧融合的化学反应</h2>
<p>从已播出的几期节目来看，新老成员之间的化学反应相当不错。刘在石作为灵魂人物继续掌控全局，与新成员之间的互动自然有趣。特别是在团队合作游戏中，新老成员各展所长，呈现出了不同于以往的节目效果。</p>
<h2>收视率表现</h2>
<p>阵容调整后的首期节目收视率达到了9.8%，相比上一季的平均收视率有明显提升。虽然距离节目巅峰期还有一定差距，但上升趋势让人看到了希望。</p>
<p>对于这档陪伴了观众十多年的节目来说，适时的改变或许是保持生命力的关键。期待《Running Man 2026》能带给我们更多欢乐。</p>`,
    category: '综艺',
    categorySlug: 'zongyi',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20variety%20show%20outdoor%20game%20set%20with%20colorful%20props%20and%20bright%20lighting%2C%20fun%20energetic%20atmosphere%2C%20television%20production%2C%20vibrant%20colors&width=800&height=450&seq=article-cover-10&orientation=landscape',
    author: '综艺达人',
    publishDate: '2026-06-20',
    readTime: '5分钟',
    views: 21300,
    tags: ['Running Man', '韩国综艺', '综艺节目', '娱乐资讯'],
    featured: false,
  },
];

export const getArticleById = (id: number) => {
  return articles.find((a) => a.id === id) || null;
};

export const getArticlesByCategory = (slug: string) => {
  return articles.filter((a) => a.categorySlug === slug);
};

export const getFeaturedArticles = () => {
  return articles.filter((a) => a.featured);
};

export const getLatestArticles = (count: number = 6) => {
  return [...articles].sort((a, b) => new Date(b.publishDate).getTime() - new Date(a.publishDate).getTime()).slice(0, count);
};